<template>
  <button class="btn btn-danger btn-sm" @click="unblock">
    Unblock
  </button>
</template>

<script>
export default {
  props: ['params'],
  methods: {
    unblock() {
      // Call parent method
      this.params.context.componentParent.integrationAction(
          // this.params.node.rowIndex,
          this.params.data.phonenumber,
          'delete'
      )
    }
  }
}
</script>